import axios from "./api";
const baseUrl = "/admin";

const ControlPanel = {
  getAllBusiness(query = null) {
    return axios.get(`${baseUrl}/business-list?${query ? query : ""}`);
  },
  getAllLocationsWithQuery(query = null) {
    return axios.get(`${baseUrl}/location-paginate?${query ? query : ""}`);
  },
  getAllLocation() {
    return axios.get(`${baseUrl}/location-list`);
  },
  getSubscription(customerId) {
    return axios.get(`${baseUrl}/payment/subscription/` + customerId);
  },
  attachBusiness(data) {
    return axios.post(`${baseUrl}/payment/attach-business`, data);
  },
  deleteBusiness(id) {
    return axios.delete(`${baseUrl}/business/${id}`);
  },


  /* 
   * Analytics
  */
  analyticsStatus(data) {
    return axios.post(`${baseUrl}/analytics-status`, data);
  },
  analyticsGrayOutStatus(data) {
    return axios.post(`${baseUrl}/location-disable`, data);
  },
  analyticStats() {
    return axios.get(`${baseUrl}/stats`);
  },
  BroadcastMessage(data){
        return axios.post(`${baseUrl}/broadcast-message`,data);
  }
};

export default ControlPanel;